import React from 'react';
import { useLocation } from 'react-router-dom';

const UnderProgress = () => {
  const location = useLocation();
  const path = location.pathname.split('/')[1];
  const pageName = path.charAt(0).toUpperCase() + path.slice(1);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      fontFamily: 'Arial, sans-serif',
    },
    title: {
      fontSize: '3rem',
      marginBottom: '1rem',
      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
    },
    message: {
      fontSize: '1.5rem',
      marginBottom: '2rem',
      textAlign: 'center',
    },
    loader: {
      width: '50px',
      height: '50px',
      border: '5px solid rgba(255,255,255,0.3)',
      borderTop: '5px solid white',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{pageName} Page</h1>
      <p style={styles.message}>We're working hard to bring you an amazing experience!</p>
      <p style={styles.message}>This page is currently under construction.</p>
      <div style={styles.loader}></div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default UnderProgress;